import SerializableObject from '@/utils/models/serializableobject.model';
import Cart from '../cart/cart.model';
import PaymentType from '../cart/paymenttype.model';

export default class CartResponse extends SerializableObject {
  Cart?: Cart;
  PaymentTypeList?: PaymentType[];
}
